import { JupiterTheme } from '@jupiterone/jupiter-web-toolkit';
import { createStyles, makeStyles } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import React from 'react';

const useStyles = makeStyles((theme: JupiterTheme) =>
  createStyles({
    icon: {
      height: 29,
      width: 29,
      strokeWidth: 2,
    },
    iconButton: {
      alignSelf: 'flex-start',
      padding: theme.spacing(1.75),
      borderRadius: theme.spacing(0.5, 0, 0, 0.5),
      height: 60,
      position: 'relative',
      color: theme.palette.coolGrey[300],
      '&:after': {
        background: theme.palette.grey[300],
        content: `''`,
        display: 'block',
        width: 1,
        height: 60,
        position: 'absolute',
        right: -1,
        top: -1,
      },
      '&:hover svg': {
        color: theme.palette.primary.dark,
      },
    },
  })
);

interface SearchIconButtonProps {
  icon: React.ReactElement;
  tooltipTitle: string;
  onClick: () => void;
}
const SearchHelp = ({ icon, tooltipTitle, onClick }: SearchIconButtonProps) => {
  const classes = useStyles();

  return (
    <Tooltip title={tooltipTitle} enterDelay={500} placement="top">
      <IconButton
        className={classes.iconButton}
        onClick={onClick}
        aria-label={tooltipTitle}
      >
        {icon}
      </IconButton>
    </Tooltip>
  );
};
export default SearchHelp;
